import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo, lazy, Suspense } from "react";
import { getGameEntry } from "../registry/game-registry.js";
const noopApi = {
  onGameCompleted: (gameName, subType, score, time, callback) => {
    console.log("[GamePlayer] onComplete:", { gameName, subType, score, time });
    callback == null ? void 0 : callback({ score, time, user: { nickname: "Guest" } });
  },
  onScoreUpdate: (gameName, subType, score, time, callback) => {
    console.log("[GamePlayer] onScoreUpdate:", { gameName, subType, score, time });
    callback == null ? void 0 : callback({ score, time, user: { nickname: "Guest" } });
  },
  loadRanking: (_gameName, _subType, callback) => {
    console.log("[GamePlayer] loadRanking (mock)");
    callback({ ranking: [], my: null });
  },
  loadState: (_gameName, _subType, callback) => {
    console.log("[GamePlayer] loadState (mock)");
    callback({});
  },
  saveState: (_gameName, _subType, data, callback) => {
    console.log("[GamePlayer] saveState (mock):", data);
    callback == null ? void 0 : callback(data);
  }
};
const noopClose = () => {
};
function GamePlayer({
  gameKey,
  user,
  api,
  isSoundOn = true,
  loadingFallback = null,
  onClose
}) {
  const entry = useMemo(() => getGameEntry(gameKey), [gameKey]);
  const adapter = api ?? noopApi;
  const effectiveUser = user ?? { nickname: "Guest" };
  const close = onClose ?? noopClose;
  const GameComponent = useMemo(
    () => entry ? lazy(entry.loader) : null,
    [entry]
  );
  if (!entry || !GameComponent) return null;
  return /* @__PURE__ */ jsxs("div", { className: "relative flex-1 overflow-hidden h-full", children: [
    /* @__PURE__ */ jsx("style", { children: `
        #penguin-game {
          position: absolute !important;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        #penguin-game canvas {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      ` }),
    /* @__PURE__ */ jsx(Suspense, { fallback: loadingFallback, children: /* @__PURE__ */ jsx(
      GameComponent,
      {
        user: effectiveUser,
        onComplete: adapter.onGameCompleted,
        onScoreUpdate: adapter.onScoreUpdate,
        loadRanking: adapter.loadRanking,
        loadState: adapter.loadState,
        saveState: adapter.saveState,
        isSoundOn,
        isFullscreen: false,
        onHandleHome: close,
        goHome: false,
        onClose: close
      }
    ) })
  ] });
}
export {
  GamePlayer
};
//# sourceMappingURL=GamePlayer.js.map
